<ts-dialog title="Invite User" (closeDialog)="discard()">
  @if (!!(teamOptions$ | async)) {
    <form class="w-full flex flex-col gap-2" ts-dialog-body [formGroup]="inviteUserForm">
      <span class="form-field">
        <p>Email</p>
        <ts-input
          class="w-1/2"
          placeholder="User email"
          autocomplete="off"
          type="text"
          formControlName="email"
          [errorMessages]="{
            duplicateName: 'This e-mail address has already been invited.',
          }"
          [roundedBorders]="false"
        ></ts-input>
      </span>

      @if (!forceRoleName) {
        <span class="form-field">
          <p>Permission Group</p>
          <ts-select
            itemKey="id"
            itemLabel="label"
            formControlName="role_id"
            class="w-1/2"
            [uiOptions]="{
              roundedBorders: false,
              placeholder: 'Permission group',
              searchPlaceholder: 'Search a permission...',
              size: 'full',
            }"
            [items]="roles"
          ></ts-select>
        </span>
      }

      <div class="form-field">
        <p>Team</p>
        <ts-select
          itemKey="id"
          itemLabel="name"
          formControlName="team_id"
          class="w-1/2"
          [hasGroups]="false"
          [uiOptions]="{
            roundedBorders: false,
            placeholder: 'Select a team',
            searchPlaceholder: 'Team name...',
            size: 'full',
          }"
          [items]="teamOptions$ | async"
        ></ts-select>
      </div>
    </form>
  } @else {
    <div class="w-full flex flex-col gap-2" ts-dialog-body>
      <ts-skeleton height="34"></ts-skeleton>
      <ts-skeleton height="34"></ts-skeleton>
      <ts-skeleton height="34"></ts-skeleton>
    </div>
  }

  <div class="ts-dialog-actions-container" ts-dialog-actions>
    <ts-button variant="secondary" (click)="discard()">
      <span>Cancel</span>
    </ts-button>
    <ts-button
      variant="primary"
      [loading]="isLoading || !(teamOptions$ | async)"
      [disabled]="isSaveBtnDisabled"
      DebounceClick
      (debounceLoading)="isDebounceLoading($event)"
      (debounceClick)="saveAndClose()"
    >
      <span *ngIf="!isLoading">Invite</span>
    </ts-button>
  </div>
</ts-dialog>
